// Module
var code = "<div flex layout=\"column\" class=\"md-padding\">\n\n    <h3 translate-once=\"general_default_values\"></h3>\n    \n</div>\n";
// Exports
module.exports = code;